import moment from 'moment'

// One place for "format this ISO stamp, or render nothing" (VA1 review #9).
export function formatDate (iso, pattern = 'DD/MM/YYYY') {
  if (!iso) return ''
  const m = moment(iso)
  return m.isValid() ? m.format(pattern) : ''
}
